import { generateTestId } from "@client-shared";

export const setUserNavTestId = (identifier: string): string =>
  generateTestId("UserNav", identifier);
